import React from 'react';
import { useLanguage } from '../translations/LanguageContext';
import { Button, ButtonGroup } from '@mui/material';

export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  
  // Hide the component if SHOW_LANGUAGE_SELECTOR is false
  if (process.env.REACT_APP_SHOW_LANGUAGE_SELECTOR !== 'true') {
    return null;
  }

  return (
    <ButtonGroup variant="text" size="small" aria-label="language switcher">
      <Button
        onClick={() => setLanguage('pl')}
        variant={language === 'pl' ? 'contained' : 'text'}
      >
        PL
      </Button>
      <Button
        onClick={() => setLanguage('en')}
        variant={language === 'en' ? 'contained' : 'text'}
      >
        EN
      </Button>
    </ButtonGroup>
  );
}; 